import React from 'react';
import { Outlet } from 'react-router-dom';

const LayoutSteps = ({  }) => {  
  return (
    <div className="layout-steps">
      <Outlet />
    </div>
  );
};


export default LayoutSteps;